import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { CustomCardComponent } from '../shared/custom-card/custom-card.component';
import { ResourcesPageComponent } from './resources-page/resources-page.component';
import { ClimatePartnerComponent } from './climate-partner/climate-partner.component';
import { ClimateProjectsComponent } from './climate-projects/climate-projects.component';
import { ClimateInitiativesComponent } from './climate-initiatives/climate-initiatives.component';
import { CardsListComponent } from '../shared/cards-list/cards-list.component';
import { PageHeaderComponent } from '../shared/components/page-header/page-header.component';

@NgModule({
  declarations: [
    ResourcesPageComponent,
    ClimateInitiativesComponent,
    ClimatePartnerComponent,
    ClimateProjectsComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    CardsListComponent,
    CustomCardComponent,
    PageHeaderComponent,
  ],
})
export class ResourcesModule {}
